module.exports = __webpack_public_path__ + "img/cloud_pending.32572c30.svg";